export const FORM_CALCULATE = 'page.calculator.form.calculate';
export const FORM_HOW_MANY_PER_DAY = 'page.calculator.form.how_many_per_day';
export const FORM_HOW_MUCH_PER_PACK = 'page.calculator.form.how_much_per_pack';
export const FORM_TELL_US_ABOUT_YOU = 'page.calculator.form.tell_us_about_you';

export const RESULTS_DID_YOU_KNOW = 'page.calculator.results.did_you_know';
export const RESULTS_EACH_JUULPOD_IS_EQUIVALENT_TO =
  'page.calculator.results.each_juulpod_is_equivalent_to';
export const RESULTS_TITLE = 'page.calculator.results.title';
export const RESULTS_TOTAL_YEARLY_SAVINGS =
  'page.calculator.results.total_yearly_savings';
export const RESULTS_USAGE = 'page.calculator.results.usage';
export const RESULTS_USAGE_FINE_PRINT =
  'page.calculator.results.usage_fine_print';
